import { SlideHeader } from 'components/Shared';
import { useStackableBreadcrumbs, useStackableContent, } from 'components/Shared/StackedContent/StackableContentContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveContext } from '../Context/ActiveContext';
import { ProductJourneyPages } from '../pages';
import ImpactClaimSlideContent from './ImpactClaimSlideContent';
const ImpactClaimSlide = ({ mobile, activity, openImpactClaimDetailSlide, }) => {
    const { t } = useTranslation();
    const { setActiveImpactClaim } = useActiveContext();
    const { deactivateActiveContent } = useStackableContent();
    const breadcrumbs = useStackableBreadcrumbs();
    const handleOpenImpactClaimSlide = (claimId) => {
        var _a;
        const selectedClaim = (_a = activity.impactClaims.edges.find((claim) => claim.node.id === claimId)) === null || _a === void 0 ? void 0 : _a.node;
        openImpactClaimDetailSlide(selectedClaim);
        setActiveImpactClaim(selectedClaim);
    };
    return (React.createElement("div", null,
        React.createElement(SlideHeader, { mobile: mobile, onPrev: deactivateActiveContent, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-location'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(ImpactClaimSlideContent, { detailNode: activity, onClaimClick: handleOpenImpactClaimSlide })));
};
export default ImpactClaimSlide;
